const mapiReady = () => typeof window !== 'undefined' && window.mapiUtils

const logMapiWarning = methodName => {
  // eslint-disable-next-line no-console
  console.warn(
    `Warning: attempted to call window.mapiUtils.${methodName}() but window.mapiUtils is not loaded.`
  )
}

const readyEventName = 'mapi-loaded'

/**
 * Requests a request ID from MAPI using window.mapiUtils and passes it to the provided callback function.
 * If window.mapiUtils is not loaded, a warning will be logged and an empty string will be passed to the callback.
 */
const getRequestID = callback => {
  if (mapiReady()) {
    window.mapiUtils.getRequestId().then(res => {
      callback(res)
    })
  } else {
    logMapiWarning('getRequestId')
    callback('')
  }
}

/**
 * Gets a promo code using window.mapiUtils and passes it to the provided callback function.
 * If window.mapiUtils is not loaded, a warning will be logged and an empty string will be passed to the callback.
 */
const getPromoCode = callback => {
  if (mapiReady()) {
    callback(window.mapiUtils.getPromoCode())
  } else {
    logMapiWarning('getPromoCode')
    callback('')
  }
}

export default {
  readyEventName,
  getRequestID,
  getPromoCode,
}
